import { GPLogo } from "../theme/logos";
import Stack from "@mui/material/Stack";
import { Link, Outlet } from "react-router-dom";
import * as routes from "../../data/links/routes";
import {
  AllCenteredColumn,
  MainTitle,
  SpacedRow,
  StyledLink,
} from "../../data/style/Style";

const FormLayout = () => {
  return (
    <Stack
      sx={{
        minHeight: "100vh",
      }}
    >
      {/* Ambient top glow */}
      <div
        style={{
          position: "fixed",
          top: -150,
          left: "50%",
          transform: "translateX(-50%)",
          width: 800,
          height: 540,
          borderRadius: "50%",
          background:
            "radial-gradient(ellipse,rgba(249,115,22,.14) 0%,rgba(249,115,22,.05) 40%,transparent 70%)",
          pointerEvents: "none",
          zIndex: 0,
          animation: "gpAmbient 4s ease-in-out infinite alternate",
        }}
      />
      <div
        style={{
          position: "fixed",
          bottom: -160,
          right: -80,
          width: 420,
          height: 420,
          borderRadius: "50%",
          background:
            "radial-gradient(ellipse,rgba(249,115,22,.07) 0%,transparent 65%)",
          pointerEvents: "none",
          zIndex: 0,
        }}
      />

      {/* Grain */}
      <div
        style={{
          position: "fixed",
          inset: 0,
          opacity: 0.18,
          zIndex: 0,
          backgroundImage:
            "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.9' numOctaves='4'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='.04'/%3E%3C/svg%3E\")",
          backgroundSize: "200px 200px",
          pointerEvents: "none",
        }}
      />
      <Stack
        sx={{
          paddingTop: 2,
          paddingLeft: 2,
          paddingRight: 2,
        }}
      >
        <Link
          style={{
            textDecoration: "none",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            width: "fit-content",
          }}
          to={routes.INDEX}
        >
          <GPLogo size={40} />
          <MainTitle fontSize={"1.1rem"} marginLeft={2}>
            Grind<span style={{ color: "#f97316" }}>&nbsp;Partner</span>
          </MainTitle>
        </Link>
      </Stack>
      <AllCenteredColumn flex={1}>
        <Outlet />
      </AllCenteredColumn>
      <SpacedRow sx={{ padding: 3 }}>
        <Stack direction={"row"} gap={2}>
          <Link style={{ textDecoration: "none" }} to={routes.POLICY}>
            <StyledLink inactive={true} sx={{ fontSize: 12 }}>
              Privacy
            </StyledLink>
          </Link>
          <Link style={{ textDecoration: "none" }} to={routes.TERMS}>
            <StyledLink inactive={true} sx={{ fontSize: 12 }}>
              Terms
            </StyledLink>
          </Link>
          <StyledLink
            href={"mailto:grindpartnerinfo@gmail.com"}
            inactive={true}
            sx={{ fontSize: 12, marginTop: 0.3 }}
          >
            Support
          </StyledLink>
        </Stack>
        <div
          style={{
            fontFamily: "Oswald, sans-serif",
            fontWeight: 700,
            fontSize: 11,
            letterSpacing: "0.12em",
            textTransform: "uppercase",
            color: "#222",
          }}
        >
          © 2025 Grind Partner
        </div>
      </SpacedRow>
    </Stack>
  );
};
export default FormLayout;
